import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../../../audi-ui-components/Button';
import IconService from '../../../audi-ui-components/icons/Service';
import IconCaution from '../../../audi-ui-components/icons/Caution';
import { gtmPush } from '../../../lib/gtm';
import { PATH_PROFILE, AUDI_BOOK_SERVICE_URL } from '../../../constants';
import LoadingOverlay from '../../../components/LoadingOverlay';
import Modal from '../../../audi-ui-components/Modal';

const ServiceHistory = ({ serviceHistory, preferredServiceLocation, dueForService, setActiveModal, activeModal, rego }) => {
    return (<>

        <div className="col-12 col-medium-6 pb-3 vehicle-details">
            <div className="aui-color-gray95 mt-3 mb-3 pb-5" style={{ height: '100%' }}>
                <div className="row h-100">

                    <div className="col-12 panel">
                        <div className="pt-4">
                            <div className="col-12 px-6">
                                <IconService />
                            </div>
                            <div className="col-12 px-6">
                                <h2 className="aui-headline-3"><b>Service History</b></h2>
                            </div>

                            <div className={`details-list px-6${serviceHistory && serviceHistory.length > 0 ? ' mt-4' : ''}`}>

                                {!serviceHistory &&
                                    <LoadingOverlay type="placeholder" />
                                }

                                {serviceHistory && serviceHistory.length <= 0 &&
                                    <div className="pt-3">No service history found for this vehicle.</div>
                                }

                                {serviceHistory &&
                                    <ul>

                                        {serviceHistory.map(({ serviceDetails }) => {
                                            return (
                                                <li className="py-1" key={'service-link-' + serviceDetails.serviceNumber} onClick={() => { setActiveModal('service-modal-' + serviceDetails.serviceNumber); gtmPush("myAudi_click", "service_history", "service_history"); }}>
                                                    <div className="item">
                                                        <div className="label">
                                                            <span>
                                                                {serviceDetails.serviceDate}
                                                            </span>
                                                        </div>
                                                        <div className="value">
                                                            <span>{serviceDetails.scheduledServiceDescription}</span>
                                                        </div>
                                                    </div>
                                                </li>
                                            );
                                        })}

                                    </ul>
                                }

                                {serviceHistory &&
                                    <div>
                                        {serviceHistory.map(({ serviceDetails }) => {
                                            return (
                                                <div key={'service-modal-' + serviceDetails.serviceNumber}>
                                                    <Modal isActive={activeModal === ('service-modal-' + serviceDetails.serviceNumber)}
                                                        closeButton
                                                        close={() => { setActiveModal(null); }}
                                                        modalStyle="layer">

                                                        <div className="modal-form py-7">
                                                            <div className="py-4">
                                                                <h1 className="aui-headline-3">
                                                                    {serviceDetails.serviceDate}
                                                                </h1>
                                                                <h1 className="aui-headline-3">
                                                                    {serviceDetails.scheduledServiceDescription}
                                                                </h1>
                                                            </div>

                                                            <div>
                                                                Dealer Name: {serviceDetails.dealerName}
                                                            </div>
                                                            <div>
                                                                Dealer Code: {serviceDetails.dealerCode}
                                                            </div>
                                                            <div>
                                                                Rego: {rego}
                                                            </div>
                                                            <div>
                                                                VIN: {serviceDetails.vin}
                                                            </div>
                                                            <div>
                                                                Service Invoice: {serviceDetails.serviceNumber}
                                                            </div>
                                                        </div>

                                                    </Modal>
                                                </div>

                                            );
                                        })}
                                    </div>
                                }

                            </div>
                        </div>
                        <div className="mt-3 buttons px-6">
                            {/* {TODO:: logic for determining Due for Service */
                                dueForService && <div className="warning mt-7 aui-color-text-red d-flex align-item-center">
                                    <IconCaution small /> <b> This vehicle is due for a service</b>
                                </div>
                            }

                            {preferredServiceLocation && (
                                <>
                                    {preferredServiceLocation.webKey &&
                                        <Button
                                            href={`${AUDI_BOOK_SERVICE_URL}${preferredServiceLocation.webKey}`}
                                            rel="noopener noreferrer" target="_blank"
                                            onClick={() => { gtmPush("myAudi", "bookMyService", "vehicle"); }}
                                            buttonType="primary"
                                            label={`Book my service at ${preferredServiceLocation.name}`}
                                        />
                                    }
                                    {(!preferredServiceLocation.webKey && preferredServiceLocation.phone) && <>Call {preferredServiceLocation.name} on <b>{preferredServiceLocation.phone}</b> to book a service</>}
                                </>
                            )}

                            <Button buttonType="secondary" onClick={() => { setActiveModal('change-dealer'); gtmPush("myAudi", "notMyDealer", "vehicle"); }}>
                                {preferredServiceLocation ? "Not your preferred service centre?" : (<>Select your <span className="d-medium-none">preferred</span> Audi Service Centre</>)}
                            </Button>

                        </div>


                    </div>

                </div>
            </div>
        </div>


    </>);
};

export default ServiceHistory;
